import type { Withdrawal } from '../model/types';

export type PolicyView = 'passed' | 'pending' | 'denied' | 'historical';

export type ApprovalView = 'pending_admin' | 'approved' | 'revoked' | 'not_required' | 'historical';

export const policyViewOf = (withdrawal: Withdrawal): PolicyView => {
  if (withdrawal.effectiveStops?.some((stop) => stop.active !== false) && withdrawal.status === 'pending') {
    return 'denied';
  }
  if (!withdrawal.policyOutcome && !withdrawal.policyChecks?.length) return 'historical';
  if (withdrawal.policyOutcome === 'passed') return 'passed';
  if (withdrawal.policyOutcome === 'denied') return 'denied';
  if (withdrawal.policyOutcome === 'pending') return 'pending';
  return 'historical';
};

export const approvalViewOf = (withdrawal: Withdrawal): ApprovalView => {
  if (withdrawal.makerKind === 'AUTO' || withdrawal.makerKind === 'B2B') return 'not_required';
  const status = withdrawal.approval?.status;
  if (status === 'APPROVED') return 'approved';
  if (status === 'REVOKED') return 'revoked';
  if (status === 'NOT_REQUIRED') return 'not_required';
  if (status === 'PENDING' || (withdrawal.status === 'pending' && withdrawal.makerKind === 'HUMAN')) {
    return 'pending_admin';
  }
  if (!withdrawal.approval && !withdrawal.makerKind) return 'historical';
  return 'historical';
};

export const canForceAddressHold = (withdrawal: Withdrawal): boolean =>
  withdrawal.status === 'pending' && withdrawal.makerKind === 'HUMAN' && withdrawal.addressHold === true;
